
/* injects from baggage-loader */

import { PlatesType } from '../types/plates';

import chefDevice from '_images/locales/chef/book.png';

// chef
export const chef = {
    device: {
        url: chefDevice,
        type: 'tablet',
        tabs: true
    },
    order: [
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: true,
            active: true
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            active: true
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false,
            active: false
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false,
            active: false
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false,
            active: false
        },
        {
            title: 'Entrada',
            value: null,
            type: PlatesType.entrance,
            show: false,
            active: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: true,
            active: true
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false,
            active: true
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false,
            active: false
        },        
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false,
            active: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false,
            active: false
        },
        {
            title: 'Prato Principal',
            value: null,
            type: PlatesType.principal,
            show: false,
            active: false
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: true
        },        
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: true
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: false
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: false
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: false
        },
        {
            title: 'Sobremesa',
            value: null,
            type: PlatesType.dessert,
            show: true,
            active: false
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: true
        },        
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: true
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: false
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: false
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: false
        },
        {
            title: 'Bebida',
            value: null,
            type: PlatesType.drink,
            show: true,
            active: false
        },
    ]
}

export default {
    chef
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tab-device-chef/tab-device-chef.const.js